export const SCREEN_XS_GRID = 576
export const SCREEN_MD_GRID = 768
export const SCREEN_LG_GRID = 992
export const SCREEN_XL_GRID_MAX = 1199


// WEBPACK FOOTER //
// ./src/constants/mediaQueries.js